import { Card, Paper, Tooltip } from '@mui/material';
import { memo, ReactElement, ElementType, ComponentPropsWithoutRef, ReactNode } from 'react';

interface InformationTooltipOwnProps<E extends ElementType = ElementType> {
  tooltipElement?: E;
  tooltipContent: ReactNode;
  children?: ReactNode;
}

type InformationTooltipProps<E extends ElementType> = InformationTooltipOwnProps<E> &
  Omit<ComponentPropsWithoutRef<E>, keyof InformationTooltipOwnProps>;

const DEFAULT_ELEMENT = Card;

export const InformationTooltip = memo(function <E extends ElementType = typeof DEFAULT_ELEMENT>({
  tooltipElement,
  tooltipContent,
  children,
  ...restProps
}: InformationTooltipProps<E>): ReactElement {
  const Tag = tooltipElement || DEFAULT_ELEMENT;

  return (
    <Tooltip
      placement='top'
      disableFocusListener
      enterTouchDelay={100}
      title={
        <Paper
          elevation={10}
          sx={{
            p: 2,
            bgcolor: 'common.white',
            color: 'common.black',
            borderRadius: '10px',
          }}
        >
          {tooltipContent}
        </Paper>
      }
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'transparent',
            maxWidth: 'none',
          },
        },
      }}
    >
      <Tag {...restProps}>{children}</Tag>
    </Tooltip>
  );
}) as <E extends ElementType = typeof DEFAULT_ELEMENT>(props: InformationTooltipProps<E>) => ReactElement;
